import React, { Component } from 'react';
import Combo from './Combo';
import ModalContenedor from '../Modales/ModalContenedor';

class SolicitarBaja extends Component {
    constructor(props) {
        super(props);
    }

    render() { 
        const {data, actions, cuenta} = this.props;
        let saldo = "$" + (data.saldoGlobal != undefined ? data.saldoGlobal : "" );
        let prohibeBaja = data.saldoGlobal > 0; 
        let modal = null;

        if(data.modalAbierto){
            modal = <ModalContenedor modalTipo={'CONFIRMADOR-BAJA'/*data.modalAbierto*/} actions={actions} data={data} cuenta={cuenta} />
        }

        return (  
        <div className='contenedorDatosIntegranteIndividualCuenta'>
            
            {modal}

            <div className={'robotoTitulo bottom-separator top-padding-xxs bottom-padding-s ' + (!prohibeBaja ? "bottom-separator-xs" : "") }>
                {"Saldo actual : " + saldo}
            </div>

            {prohibeBaja && <div className='bajaCuentaAdvertenciaSaldo'>¡Atención! No es posible solicitar la baja porque la cuenta posee saldo</div>}

            <div className= "tableroProcesos bottom-separator-xs">
                <div>
                    <Combo 
                    infoData={data.bajaCuentaPrepaga.motivosBaja} 
                    nombreAction={"motivoBajaId"} 
                    selectCombo={actions.selectValorBaja} 
                    selecciones={data.bajaCuentaPrepaga} 
                    placeholder={"un motivo..."} 
                    titulo="Motivo de baja"
                    id={"comboBaja" + ( data.bajaCuentaPrepaga.motivoBajaId ? data.bajaCuentaPrepaga.motivoBajaId : "")} 
                    />
                </div>

                <div className='fillSpaceFlex'>
                    <div className='robotoTitulo bottom-separator-xs'>Comentarios adicionales</div>
                    <textarea value={data.bajaCuentaPrepaga.comentarioBaja} onChange={(e)=>actions.selectValorBaja("comentarioBaja",e.target.value)} maxLength={99} disabled={prohibeBaja} className='textAreaBajaCuenta' placeholder= "Ingrese comentarios..."></textarea>
                </div>

            </div>

            <div>
                <button disabled={prohibeBaja} onClick={() => actions.solicitarBaja()} className={"btn pull-right " + (!prohibeBaja ? "btn-cta" : "btn-disabled") }>Dar de baja</button>
            </div>

        </div>);
    }
}
 
export default SolicitarBaja;